import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@material-ui/core";
import DialogModalHeader from "../../../../components/dialogModal/dialogModalHeader";
import { useConnectedAppProps } from "../connectedApps";

const DisplayAppInfo = () => {
  const { appInfo, handleAppAccess, handleClose } = useConnectedAppProps();
  const {
    application_name,
    consented_on,
    application_id,
    scopes,
    terms_of_service,
    privacy_policy,
  } = appInfo;

  const formatDate = (epoch) => {
    if (!epoch) return "";
    const date = new Date(epoch * 1000);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  };

  return (
    <div className="account-modal-body">
      <div className="app-scroll-body">
        <DialogModalHeader title={application_name} handleClose={handleClose} />
        
        <div className="line-break">
          <FormattedMessage
            defaultMessage="You gave {app_name} access to the following information. You can choose to remove the application's access."
            values={{ app_name: application_name }}
          />
        </div>
        
        <div className="line-break">
          <FormattedMessage
            defaultMessage="Find out how {app_name} manages your data by reviewing its {terms_of_service} and {privacy_policy}."
            values={{
              app_name: application_name,
              terms_of_service: <a href={terms_of_service}  target="_blank"
              rel="noopener noreferrer">Terms of Service</a>,
              privacy_policy: <a href={privacy_policy}  target="_blank"
              rel="noopener noreferrer">Privacy Policy</a>,
            }}
          />
         
        </div>

       <div className="line-break">
        <div className="title-bold"><FormattedMessage defaultMessage="Connected on:" /></div>
        <div style={{ marginTop: "0.5rem" }}>{formatDate(consented_on)}</div>
        </div>

        <div className="title-bold">
          <FormattedMessage
            defaultMessage="{app_name} can:"
            values={{ app_name: application_name }}
          />
        </div>
        <ul>
          <li className="scope-desc">
            <FormattedMessage defaultMessage="See your user profile data including your given name, last name,
            email address, locale, and profile picture."/>
          </li>
          {scopes &&
            scopes.map((scope, i) => (
              <li className="scope-desc" key={i}>
                {scope}
              </li>
            ))}
        </ul>
      </div>
      <div>
        <Button
          className="action-button line-break"
          onClick={(e) => handleAppAccess(e, application_id, "revoke")}
          color="primary"
          disableElevation
          variant="contained"
        >
          <FormattedMessage defaultMessage="Revoke access" />
        </Button>
      
        <Button
          className="outline-button"
          onClick={(e) => handleAppAccess(e, application_id, "info")}
          color="primary"
          disableElevation
          variant="outlined"
        >
          <FormattedMessage defaultMessage="Keep access" />
        </Button>
      </div>
    </div>
  );
};

export default DisplayAppInfo;
